import { isEmpty } from 'lodash';
import { useMemo, useState } from 'react';
import { API } from '@shared/types/api';

export interface SelectedUsers {
  token: string | null;
  userIds: number[] | null;
}

export interface DefaultPersonSelectionHooks {
  selectedUsers?: SelectedUsers;
  filteredUsers?: API.ShortUserFragment[];
  onFilter(filter: string);
  currentFilter: string;
  onPersonSelected(userId: number);
  onMeSelected();
}

export function useDefaultPersonSelectionHooks(
  users: API.ShortUserFragment[],
  selectedUsers: SelectedUsers,
  onPersonSelected: (userId: number) => void,
  onMeSelected: () => void,
): DefaultPersonSelectionHooks {
  const [filterQuery, setFilterQuery] = useState<string>('');

  const filteredUsers = useMemo(() => {
    if (isEmpty(filterQuery)) {
      return users;
    } else {
      const lowercaseQuery = filterQuery.toLowerCase();
      return users.filter(user => {
        return (
          user.fullName.toLowerCase().includes(lowercaseQuery) ||
          user.username.toLowerCase().includes(lowercaseQuery)
        );
      });
    }
  }, [filterQuery, users]);

  return {
    selectedUsers,
    filteredUsers,
    onFilter: setFilterQuery,
    currentFilter: filterQuery,
    onPersonSelected,
    onMeSelected,
  };
}
